import { Box, Grid, Typography, IconButton, Tab, Tooltip, Button } from '@mui/material'
import Loader from '../../../../components/loader'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import { DinamicForm } from '../../../../components/dinamicForm'
import { icons } from '../../../../utils/icons'
import { BreadCrumb, CustomTable, SnackSimple } from '../../../../components'
import { useStyles } from './styles'
import { useTranslation } from 'react-i18next'
import { useBody } from './body'
import { useContextState } from '../../../../hooks/theme'
import { LoadingButton, TabContext, TabList, TabPanel } from '@mui/lab'
import SimpleModal from '../../../../components/modal/simpleModal'
import { AddUsers } from './fragments'
import { useLayoutEffect, useMemo } from 'react'
import { CustomPaper } from '../../../../components/CustomPaper'
import { Header } from '../detail/fragments'
import { useNavigate } from 'react-router-dom'
import StatusComponent from '../../../../components/status'
import SelectActionPlan from './components/selectActionPlan'
import { TableType } from './interface'

const LinkingUsersToQuestionnaires = () => {
  const body = useBody()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { colors } = useContextState()
  const styles = useStyles()
  const typeQuestionnairePermissions = useMemo(() => body.itemTypeQuestionnairePermissions({ t }), [])
  useLayoutEffect(() => {
    body.resetValues()
  }, [])

  if (body?.loadings.main) {
    return (
      <Box sx={styles.containerLoader}>
        <Loader />
      </Box>
    )
  }
  return (
    <Box sx={styles.container}>
      <BreadCrumb
        Children={(
          <StatusComponent type="chip" color={body.typeStatus?.color} msg={body.typeStatus?.text} />
        )}
      />

      <Header
        averagePoints={body.questionnarieData?.averagePoints ?? 0}
        dataHeader={body.questionnarieData?.dataHeader}
        handleNavigate={() => {
          navigate(`/dashboard/questionnarie/edit/${body.id}`)
        }}
        actionPlan={body.questionnarieData?.dataHeader?.option == '0'}
        isSectionConfig={Boolean(body.questionnarieData?.isSectionConfig)}
        openGeneralConfig={() => { }}
        view="permissions"
        detail={{
          id: body.questionnarieData?.dataHeader?.parentId?.toString() || '',
          version: body.questionnarieData?.dataHeader?.version?.toString() || '1'
        }}
      />

      <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
        {
          body.tabValue == '2' && (
            <Grid container columnSpacing={1} alignItems="center">
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12} sx={{ position: 'relative' }}>
                <FiltersDrawer m={{ mt: 2 }} cleanFilter={body.filter.cleanFilter} count={body.filter.counter} right={-50} top={0}>
                  <Box>
                    <DinamicForm input={Object.values(body.input ?? {})} values={body.filter.filterData ?? {}} onChange={body.filter.onChange} filter={true} legacyErrors />
                  </Box>
                </FiltersDrawer>
              </Grid>
            </Grid>
          )
        }

        {(body.filter.counter ?? 0) > 0 && <IconButton onClick={body.filter.cleanFilter}>{icons('clean')}</IconButton>}

        <TabContext value={body.tabValue}>
          <Box sx={styles.containerTabList}>
            <Box>
              <Typography fontWeight={'bold'}>{t('Questionarie.permissions.assigningQuestionnairePermissions')}</Typography>

              {!!body.usersToEndpoint.usersWithoutPersmissions?.length && (<Typography sx={styles.subtitle}>{t("general.messages.errors.usersNeedAtLeastOnePermissopn")}</Typography>)}
            </Box>

            <TabList onChange={body.handleChange} sx={styles.tabList} aria-label="lab API tabs example">
              <Tooltip
                title={t('general.editQuestinnaire')}
                children={<IconButton onClick={body.goToEdit} sx={styles.edit}>{icons('edit')}</IconButton>}
              />
              <Tab label={t('Questionarie.permissions.addUsers')} value="1" />
              <Tab label={
                <Box sx={styles.tab2}>
                  <Typography>{t('Questionarie.permissions.assigningPermissions')}</Typography>
                  {
                    body.tabValue == '2' && (
                      <LoadingButton
                        loading={!!body.loadings?.submit}
                        disabled={!!body.usersToEndpoint.usersWithoutPersmissions?.length || (!body.table.row?.length && !Object.values(body.usersToEndpoint?.usersOld)?.length)}
                        variant="contained"
                        onClick={() => {
                          const changed = body.validateChange()
                          body.submit({ response: true, payload: { checksUser: body.checksUser, ...body.usersToEndpoint, table: body.table.row, thereAreChanged: changed } })
                        }}
                      >
                        {t(`general.save`)}
                      </LoadingButton>
                    )
                  }
                </Box>
              } value="2" />
            </TabList>
          </Box>

          <TabPanel sx={styles.tabContext} value="1">
            <AddUsers
              cleanFilter={() => { body.createFilter.cleanFilter() }}
              userList={body.modalLoad?.tmpUsuers as Record<string, string>[]}
              open={body.modalCreate.open}
              close={body.cancelSearchUsers}
              rigthItem={<DinamicForm input={Object.values(body.inputCreate ?? {})} onChange={body.createFilter.onChange} errors={body.createFilter.errors} values={body.createFilter.filterData} />}
              userAmount={body.modalLoad?.tmpUsuers?.length ?? 0}
              searchButton={{
                disabled: !body.createFilter.query?.filter,
                loading: !!body.loadings.search,
                onClick: body.searchUsers
              }}
              loadData={{
                loading: !!body.loadings.load,
                onClick: body.loadUsers
              }}
            />
          </TabPanel>

          <TabPanel sx={styles.tabContext} value="2">
            <CustomPaper elevation={2} sx={{ padding: 3 }}>
              <Box sx={styles.headerSecondTab}>
                <Box>
                  <Typography sx={styles.userAmount}>{body.table.row?.length} {t('Questionarie.permissions.users')}</Typography>
                  <Typography sx={styles.questionnaireAccess}>{t('Questionarie.permissions.questionnaireAccess')}</Typography>
                  {/* <Button variant='primary_c'>Cuestionatio</Button>

                  <Button variant='text'>Folios</Button> */}
                  
                </Box>
                <Box>
                  {
                  !!body.listUserToDelete?.some(item => !!item) && (
                    <Button
                      sx={styles.delete}
                      onClick={() => {
                        body.handleDelete()
                      }}
                    >
                      {t('general.deleteSelectedUsers')}
                    </Button>
                  )
                }
                  <SelectActionPlan
                      value={body.byQuesationarie ?? true/* !!actionPlanOfStores */}
                      onChange={(_, value) => {
                        body.handleByQuestionarie(value)
                        if(body.tableCurrent==TableType.QUESTIONNAIRE){
                          body.selectTablePermission({value:TableType.FOLIO})
                        }else{
                          body.selectTablePermission({value:TableType.QUESTIONNAIRE})
                        }
                        //TableType.QUESTIONNAIRE
                      }}
                      /* exclusive={true} */
                      items={typeQuestionnairePermissions}
                    />
                  </Box>
              </Box>

              <CustomTable
                ref={body.refTable}
                name="Informe General"
                dontRefresh
                /* customeColumn={body.columns.customeColumn} */
                column={body.columns.columnMain}
                row={body.rowContent({ list: body.table.row })}
                selected={-1}
              />
            </CustomPaper>
          </TabPanel>
        </TabContext>
      </Grid>

      <SnackSimple close={body.closeSnackbar} open={body.snackbar.open} type={body.snackbar.type} message={body.snackbar.message} />

      <SimpleModal
        open={!!body.openModal?.open}
        close={() => { if (body.openModal?.cancel) { body.openModal?.cancel() } }}
        title={body.openModal?.title ?? ""}
        description={body.openModal?.description ?? ""}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => { if (body.openModal?.cancel) { body.openModal?.cancel() } }}
        loadingButton
        next={() => { if (body.openModal?.confirm) { body.openModal?.confirm() } }}
      />
    </Box>
  )
}

export default LinkingUsersToQuestionnaires
